module.exports = __webpack_public_path__ + "static/media/menu-less-white@3x.efeca09b.png";